import React from 'react';
import { Skeleton, Grid } from '@mui/material';

const RegimenInfoSkeleton = () => {
  // calculamos la altura en px aproximada usando line-height
  const lineHeightPx = 15 * 1.5;

  return (
    <Grid item xs={12}>
      <Skeleton variant="text" width="70%" height={lineHeightPx} />
      <Skeleton variant="text" width="50%" height={lineHeightPx} />
    </Grid>
  );
};

export default RegimenInfoSkeleton;
